import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import PricingStore from 'stores/plugins/pricing';
import PricingActionCreator from 'action_creators/pricing';
import ModalActionCreator from 'action_creators/modal';
import { t } from 'services/translation';
import { CancellationPolicyText, CancellationPolicyLink } from 'views/plugins/confirmation/styles';
import './index.scss';

class CheckoutSummaryCancellationPolicy extends React.Component {
  static displayName = 'CheckoutSummaryCancellationPolicy';

  static propTypes = {
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    has_cancellation: PropTypes.bool.isRequired,
    bookingId: PropTypes.number,
    is_mobile: PropTypes.string.isRequired,
  };

  static defaultProps = {
    description: '',
    name: '',
    has_cancellation: false,
    is_mobile: null,
  };

  componentDidMount() {
    const params = this.props.bookingId
      ? { bookingId: this.props.bookingId }
      : {};

    // Add time from props if available (for server-rendered data)
    if (this.props.time) {
      params.time = this.props.time;
    }

    PricingActionCreator.preview(params);
    PricingStore.changed.add(this._pricingChanged);
  }

  componentWillUnmount() {
    PricingStore.changed.remove(this._pricingChanged);
  }

  _pricingChanged = () => {
    this.setState({
      zero_priced: PricingStore.state.get('zero_priced'),
      fully_discounted: PricingStore.state.get('fully_discounted'),
      includes_booking_fee:
        parseFloat(PricingStore.state.get('booking_fee')) > 0,
    });
  };

  _totalIsZero = () => {
    return this.state.zero_priced || this.state.fully_discounted;
  };

  _showPopup = (e) => {
    e.preventDefault();
    ModalActionCreator.show({
      content: this._popupContent(),
      triggeringElement: e.currentTarget,
      className: 'small CancellationPolicy-Modal',
    });
  };

  _renderText = () => {
    return (
      <div>
        <p>{t(this.props.description)}</p>
      </div>
    );
  };

  _popupContent = () => {
    return (
      <div className="CancellationPolicy-Modal-content">
        <div>
          <b>{t('CANCELLATION_POLICY')}</b>
        </div>
        <hr />
        {this._renderText()}
      </div>
    );
  };

  _renderCancellationPolicyTrigger = () => {
    const { description, is_mobile } = this.props;
    const translatedString = t(description);
    const translatedStringLength = is_mobile ? 150 : 60;

    return (
      <CancellationPolicyLink
        href="#"
        className="brand-color responsive-truncate cancellation-policy-link"
        onClick={this._showPopup}
        data-testid="cancellation-policy-in-checkout-card"
      >
        {_.str.truncate(translatedString, translatedStringLength)}
      </CancellationPolicyLink>
    );
  };

  render() {
    if (this.props.noShow) return null;

    return (
      <div className="CheckoutSummary-ContentBox Cancellation-Policy">
        <table className="section">
          <tbody>
            <tr>
              <td>
                <CancellationPolicyText>
                  {t('CANCELLATION_POLICY')}
                </CancellationPolicyText>
              </td>
              <td>
                {this.props.has_cancellation
                  ? this._renderCancellationPolicyTrigger()
                  : t('NO_CANCELLATIONS')}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default CheckoutSummaryCancellationPolicy;
